"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _analyticsPusherLibrary = require("../analyticsPusherLibrary");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    var customerSettings;
    return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return _analyticsPusherLibrary.analyticsPusherLibrary.getCustomerDetails();

                case 2:
                    customerSettings = _context.sent;

                    if (!(customerSettings === null)) {
                        _context.next = 5;
                        break;
                    }

                    return _context.abrupt("return");

                case 5:
                    _context.next = 7;
                    return _analyticsPusherLibrary.analyticsPusherLibrary.preventMultiplePushes(1500);

                case 7:
                    if (!_context.sent) {
                        _context.next = 9;
                        break;
                    }

                    return _context.abrupt("return");

                case 9:
                    _context.next = 11;
                    return _analyticsPusherLibrary.analyticsPusherLibrary.pushLogin();

                case 11:
                    _context.next = 13;
                    return _analyticsPusherLibrary.analyticsPusherLibrary.pushViewList();

                case 13:
                    _context.next = 15;
                    return _analyticsPusherLibrary.analyticsPusherLibrary.pushProductDetail();

                case 15:
                    _context.next = 17;
                    return _analyticsPusherLibrary.analyticsPusherLibrary.pushPurchase();

                case 17:
                    _context.next = 19;
                    return _analyticsPusherLibrary.analyticsPusherLibrary.pushSearch();

                case 19:
                case "end":
                    return _context.stop();
            }
        }
    }, _callee, this);
}));
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/analyticsPusher.js
// module id = 572
// module chunks = 0 1